import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ic-commodity-classifier',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-commodity-classifier.html',
})
export class IcCommodityClassifierComponent {
  /** The starting color of the icon gradient. */
  @Input() startColor: string | null = null;

  /** The ending color of the icon gradient. */
  @Input() endColor: string | null = null;

  /** The opacity of the icon. Defaults to 1. */
  @Input() opacity = 1;

  /** The width of the icon. Defaults to 21. */
  @Input() width: number | string = 21;

  /** The height of the icon. Defaults to 21. */
  @Input() height: number | string = 21;

  /** Default color used when no gradient is provided. */
  @Input() defaultColor = '#B8C0C6';

  /** Unique ID for the SVG gradient. */
  gradientId = `classifierGradient-${Math.random().toString(36).slice(2)}`;

  /** Checks if both startColor and endColor are provided and non-empty. */
  get hasGradient(): boolean {
    return (
      typeof this.startColor === 'string' &&
      typeof this.endColor === 'string' &&
      this.startColor.trim() !== '' &&
      this.endColor.trim() !== ''
    );
  }
}
